
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'
import LazyImg from '@xt/www/components/lazyImg/index.vue'

import type { PublicCourseItem } from '@xt/client/entities/home-v2/public-course'

@Component({
  components: {
    LazyImg
  }
})
export default class extends Vue {
  @Prop() dataSource: PublicCourseItem

  handleClick() {
    this.$emit('click', this.dataSource.id)
  }

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
